import { createPageWithSize } from '@/components/canvas/page/createPage';
import { toCanvasData } from './serializeDocument';

export const DEFAULT_SLIDE_SIZE = { width: 1920, height: 1080 };
export const DEFAULT_POSTER_SIZE = { width: 1080, height: 1920 };
export const DEFAULT_DISPLAY_SIZE = { width: 1080, height: 1920 };

/** 写入 knowledge_bases.content 的初始 CanvasData（单页空白） */
export function buildInitialCanvasContent(size: { width: number; height: number }) {
  const page = createPageWithSize(size.width, size.height);
  return toCanvasData([page], [], 1) as unknown as Record<string, unknown>;
}
